import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'

import { Box, Divider, Grid, List, ListItemButton, Typography, useTheme } from '@mui/material'

import IconArrow from './assets/images/arrow.svg'
import { buildPolicySearch } from './utils'

type Props = {
  list: {
    root: boolean
    id: string
    title: string
    uri: string
  }[]
}

//TODO: Apply common list component
export default function ConsentList({ list }: Props) {
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const policySearch = buildPolicySearch(searchParams)
  const theme = useTheme()
  return (
    <Box sx={{ marginBottom: '48px' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <List sx={{ marginTop: '60px', width: { xs: '100%', md: '1040px' }, padding: '0' }}>
          <Divider />
          {list.map(
            (terms, index) =>
              !terms.root && (
                <Box key={terms.id} sx={{ width: '100%' }}>
                  <ListItemButton
                    sx={{ padding: '0px' }}
                    onClick={() => navigate(`${location.pathname}/${terms.id}${policySearch}`, { state: { consent: terms } })}
                    data-testid='ListItemButton953BF9C0'
                  >
                    <Grid container justifyContent='space-between' sx={{ padding: { xs: '30px 24px', md: '37px 20px 37px 0' } }}>
                      <Typography
                        variant='body1'
                        color={theme.palette.mode === 'dark' ? '#fefefe' : '#010101'}
                        sx={{ fontSize: '20px' }}
                      >
                        {terms.title}
                      </Typography>
                      <Box component='img' src={IconArrow} alt='' />
                    </Grid>
                  </ListItemButton>
                  {list.length === index + 1 ? '' : <Divider />}
                </Box>
              )
          )}
          <Divider />
        </List>
      </Box>
    </Box>
  )
}
